import store from '../store';

export default {
    authentication(to, from, next) {
        if (store.getters['authentication/getToken'] === '') {
            store.dispatch('authentication/loadToken');
        }

        if (to.path !== '/auth' && store.getters['authentication/getToken'] === '') {
            next('/auth');
        } else if (to.path === '/auth' && store.getters['authentication/getToken'] !== '') {
            next('/');
        } else {
            next();
        }
    },
    guard(to, from, next) {
        this.authentication(to, from, next);
    },
};
